import { FormControl, MenuItem, Select, Stack, SxProps, Typography } from '@mui/material';
import moment from 'moment';
import useTtsElevenlabsVoices from '../../../hooks/useTtsElevenLabsVoices';

type Props = {
    elevenLabsApiKey: string;
    ttsModelId?: string | undefined | null;
    handleTtsModelIdChange: (modelId: string | null) => void;
    size?: 'small' | 'medium';
    disabled?: boolean;
    sx?: SxProps;
};

const TtsElevenLabsVoiceModelSelector = (props: Props) => {
    const { elevenLabsApiKey, ttsModelId, handleTtsModelIdChange, size, disabled, sx } = props;

    const { data: elevenLabsVoices, isLoading: loading } = useTtsElevenlabsVoices(!!elevenLabsApiKey);

    return (
        <FormControl fullWidth error={!loading && (!ttsModelId || ttsModelId === '')}>
            <Select
                id="tts-model"
                fullWidth
                variant="outlined"
                size={size}
                disabled={disabled || !elevenLabsApiKey || loading}
                value={ttsModelId ? ttsModelId : ''}
                displayEmpty
                onChange={e => {
                    handleTtsModelIdChange(e.target.value);
                }}
                sx={sx}
            >
                {loading && <MenuItem disabled>Loading...</MenuItem>}
                {elevenLabsVoices?.length === 0 && <MenuItem disabled>No voices available</MenuItem>}
                {elevenLabsVoices && elevenLabsVoices.length > 0 && <MenuItem value="">Select a Voice model</MenuItem>}
                {elevenLabsVoices
                    ?.sort((a, b) => moment.unix(b?.createdAtUnix || 0).diff(moment.unix(a?.createdAtUnix || 0)))
                    .map(voice => (
                        <MenuItem key={voice.voiceId} value={voice.voiceId}>
                            <Stack direction="row" spacing={1} alignItems="center" justifyContent={'space-between'} sx={{ width: '100%' }}>
                                <Typography variant="body1">{voice.name}</Typography>
                                <Typography variant="body1" color={'text.secondary'}>
                                    {voice.createdAtUnix ? moment.unix(voice.createdAtUnix).format('L') : 'N/A'}
                                </Typography>
                            </Stack>
                        </MenuItem>
                    ))}
            </Select>
        </FormControl>
    );
};

export default TtsElevenLabsVoiceModelSelector;
